import { createAction, props } from '@ngrx/store';
import { IError } from '@app-root-interfaces';

export const addError = createAction('[Error] Add Error', props<{ error: IError }>());

export const nextError = createAction('[Error] Next Error');
